/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	PoliJobsPotentialCandidateDTO,
	PoliJobsPotentialCandidateDTOFromJSON,
	PoliJobsPotentialCandidateDTOFromJSONTyped,
	PoliJobsPotentialCandidateDTOToJSON,
} from "./PoliJobsPotentialCandidateDTO";

/**
 *
 * @export
 * @interface PoliJobsPotentialCandidateDTOPagedResponse
 */
export interface PoliJobsPotentialCandidateDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof PoliJobsPotentialCandidateDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof PoliJobsPotentialCandidateDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof PoliJobsPotentialCandidateDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<PoliJobsPotentialCandidateDTO>}
	 * @memberof PoliJobsPotentialCandidateDTOPagedResponse
	 */
	data?: Array<PoliJobsPotentialCandidateDTO> | null;
}

export function PoliJobsPotentialCandidateDTOPagedResponseFromJSON(
	json: any
): PoliJobsPotentialCandidateDTOPagedResponse {
	return PoliJobsPotentialCandidateDTOPagedResponseFromJSONTyped(json, false);
}

export function PoliJobsPotentialCandidateDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): PoliJobsPotentialCandidateDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(PoliJobsPotentialCandidateDTOFromJSON),
	};
}

export function PoliJobsPotentialCandidateDTOPagedResponseToJSON(
	value?: PoliJobsPotentialCandidateDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(PoliJobsPotentialCandidateDTOToJSON),
	};
}
